import Swal from "sweetalert2";

export const CustomSwal = Swal.mixin({
	customClass: {
		confirmButton: "btn-shop btn-shop-next mx-2",
		cancelButton: "btn-shop btn-shop-cancel mx-2",
	},
	buttonsStyling: false,
});
